<template>
	<!-- <ty-modal :visible="true" :before-close="handleClose" :fullscreen="isCollapse" width="500px"> -->
	<div v-if="instance_id">
		<Create class="mt-3" :instance-id="instance_id" @created="update" />
		<Table ref="list" class="mt-4" :instance-id="instance_id" />
		<router-view />
	</div>
	<!-- </ty-modal> -->
</template>

<script>
	import Create from '../components/ShopBrand/ShopInventoryBrandCreateForm'
	import Table from '../components/ShopBrand/ShopInventoryBrandsTable'
	import {
		IsCollapseMixin
	} from '@/mixins/UI';
	// import Project from '../../components/Project'
	// import axios from 'axios';
	export default {
		data() {
			return {
				loading: false,
				page: 1
			}
		},
		mixins: [
			IsCollapseMixin
		],
		inject: ['getInstance'],
		components: {
			Create,
			Table
		},
		computed: {
			instance_id() {
				const instance = this.getInstance()
				if (instance) return instance.id
				return null
			}
		},
		methods: {
			handleClose() {
				this.$router.back();
			},
			update() {
				this.$refs.list.get();
			}
		}
	}
</script>